<template>
  <div>
    <h2 class="h2  text-light">Contact</h2>
    <h1 class="h1">Gegevens van ophaal- en afleveradres</h1>

    <div class="row-2">
      <div class="card">
        <h2 v-if="typeTransport !== 'verhuizing'" class="h2">
          <i class="fas fa-map-marker-alt step-icon"></i> Ophaaladres
        </h2>
        <h2 v-else class="h2">
          <i class="fas fa-map-marker-alt step-icon"></i> Ophalen inboedel
        </h2>
        <hr />
        <div class="row-1">
          <div
            class="form-group"
            :class="{
              'form-error': !$v.ophalen.required && $v.ophalen.$error
            }"
          >
            <label>Ophalen op begane grond of verdieping?</label>
            <select v-model="ophalen" name="ophalen">
              <option disabled value="" selected>Selecteer een optie</option>
              <option value="beganegrond">Begane grond</option>
              <option value="1">Verdieping 1</option>
              <option value="2">Verdieping 2</option>
              <option value="3">Verdieping 3</option>
              <option value="4">Verdieping 4</option>
              <option value="5">Verdieping 5</option>
              <option value="6">Verdieping 6</option>
              <option value="7">Verdieping 7</option>
              <option value="8">Verdieping 8</option>
              <option value="9">Verdieping 9</option>
              <option value="10">Verdieping 10</option>
              <option value="11">Verdieping 11 of hoger</option>
            </select>
          </div>
          <div
            class="form-group"
            v-if="ophalen !== 'beganegrond' && ophalen !== ''"
            :class="[
              { disabled: ophalen === 'beganegrond' },
              {
                'form-error': !$v.ophalenLift.required && $v.ophalenLift.$error
              }
            ]"
          >
            <label>Is er een lift aanwezig?</label>
            <select v-model="ophalenLift" :disabled="ophalen === 'beganegrond'">
              <option disabled value="">Selecteer een optie</option>
              <option value="ja">Ja, er is een lift aanwezig</option>
              <option value="nee">Nee, er is geen lift aanwezig</option>
            </select>
          </div>
          <div
            v-if="typeTransport !== 'verhuizing'"
            class="form-group"
            :class="{
              'form-error':
                !$v.ophaalAdres.contact.required &&
                $v.ophaalAdres.contact.$error
            }"
          >
            <label>Overige gegevens:</label>
            <input
              v-model="ophaalAdres.contact"
              type="text"
              placeholder="Contactpersoon"
            />
          </div>
          <div
            v-if="typeTransport !== 'verhuizing'"
            class="form-group"
            :class="{
              'form-error':
                !$v.ophaalAdres.telefoon.required &&
                $v.ophaalAdres.telefoon.$error
            }"
          >
            <input
              v-model="ophaalAdres.telefoon"
              type="text"
              placeholder="Telefoonnummer"
            />
          </div>
          <div
            class="form-group"
            :class="{
              'form-error':
                !$v.ophaalAdres.adres.required && $v.ophaalAdres.adres.$error
            }"
          >
            <input
              v-model="ophaalAdres.adres"
              type="text"
              placeholder="Straat en huisnr."
            />
          </div>
          <div
            class="form-group"
            :class="{
              'form-error':
                !$v.ophaalAdres.postcode.required &&
                $v.ophaalAdres.postcode.$error
            }"
          >
            <input
              v-model="ophaalAdres.postcode"
              type="text"
              placeholder="Postcode"
            />
          </div>
          <div
            class="form-group"
            :class="{
              'form-error':
                !$v.ophaalAdres.plaatsnaam.required &&
                $v.ophaalAdres.plaatsnaam.$error
            }"
          >
            <input
              v-model="ophaalAdres.plaatsnaam"
              type="text"
              placeholder="Plaats"
            />
          </div>
          <div class="form-group">
            <input v-model="ophaalAdres.land" type="text" placeholder="Land" />
          </div>
          <div class="form-group">
            <textarea
              v-model="ophaalAdres.opmerkingen"
              placeholder="Typ hier uw eventuele vragen/opmerkingen"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="card">
        <h2 v-if="typeTransport !== 'verhuizing'" class="h2">
          <i class="fas fa-map-marker-alt step-icon"></i> Afleveradres
        </h2>
        <h2 v-else class="h2">
          <i class="fas fa-map-marker-alt step-icon"></i> Afleveren inboedel
        </h2>
        <hr />
        <div class="row-1">
          <div
            class="form-group"
            :class="{
              'form-error': !$v.aflever.required && $v.aflever.$error
            }"
          >
            <label>Ophalen op begane grond of verdieping?</label>
            <select v-model="aflever">
              <option disabled value="">Selecteer een optie</option>
              <option value="beganegrond">Begane grond</option>
              <option value="1">Verdieping 1</option>
              <option value="2">Verdieping 2</option>
              <option value="3">Verdieping 3</option>
              <option value="4">Verdieping 4</option>
              <option value="5">Verdieping 5</option>
              <option value="6">Verdieping 6</option>
              <option value="7">Verdieping 7</option>
              <option value="8">Verdieping 8</option>
              <option value="9">Verdieping 9</option>
              <option value="10">Verdieping 10</option>
              <option value="11">Verdieping 11 of hoger</option>
            </select>
          </div>
          <div
            class="form-group"
            v-if="aflever !== 'beganegrond' && aflever !== ''"
            :class="[
              { disabled: aflever === 'beganegrond' },
              {
                'form-error': !$v.afleverLift.required && $v.afleverLift.$error
              }
            ]"
          >
            <label>Is er een lift aanwezig?</label>
            <select v-model="afleverLift" :disabled="aflever === 'beganegrond'">
              <option value="ja">Ja, er is een lift aanwezig</option>
              <option value="nee">Nee, er is geen lift aanwezig</option>
            </select>
          </div>
          <div
            v-if="typeTransport !== 'verhuizing'"
            class="form-group"
            :class="{
              'form-error':
                !$v.afleverAdres.contact.required &&
                $v.afleverAdres.contact.$error
            }"
          >
            <label>Overige gegevens:</label>
            <input
              v-model="afleverAdres.contact"
              type="text"
              placeholder="Contactpersoon"
            />
          </div>
          <div
            v-if="typeTransport !== 'verhuizing'"
            class="form-group"
            :class="{
              'form-error':
                !$v.afleverAdres.telefoon.required &&
                $v.afleverAdres.telefoon.$error
            }"
          >
            <input
              v-model="afleverAdres.telefoon"
              type="text"
              placeholder="Telefoonnummer"
            />
          </div>
          <div
            class="form-group"
            :class="{
              'form-error':
                !$v.afleverAdres.adres.required && $v.afleverAdres.adres.$error
            }"
          >
            <input
              v-model="afleverAdres.adres"
              type="text"
              placeholder="Straat en huisnr. "
            />
          </div>
          <div
            class="form-group"
            :class="{
              'form-error':
                !$v.afleverAdres.postcode.required &&
                $v.afleverAdres.postcode.$error
            }"
          >
            <input
              v-model="afleverAdres.postcode"
              type="text"
              placeholder="Postcode"
            />
          </div>
          <div
            class="form-group"
            :class="{
              'form-error':
                !$v.afleverAdres.plaatsnaam.required &&
                $v.afleverAdres.plaatsnaam.$error
            }"
          >
            <input
              v-model="afleverAdres.plaatsnaam"
              type="text"
              placeholder="Plaats"
            />
          </div>
          <div class="form-group">
            <input v-model="afleverAdres.land" type="text" placeholder="Land" />
          </div>

          <div class="form-group">
            <textarea
              v-model="afleverAdres.opmerkingen"
              placeholder="Typ hier uw eventuele vragen/opmerkingen"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="error" v-if="$v.$error">
      Niet alle velden binnen deze stap zijn goed ingevuld.
    </div>
    <button @click="nextStep" class="btn btn__filled w-100">
      Volgende
    </button>
    <button
      @click="goToPreviousRoute"
      class="btn btn__simple btn__left btn__backbt"
    >
      <i class="fas fa-chevron-left"></i> Terug
    </button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required, requiredUnless, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "Service",
  mounted() {
    if (this.fromLocation !== null) {
      this.ophaalAdres.plaatsnaam = this.fromLocation.address.freeformAddress;
      this.ophaalAdres.land = this.fromLocation.address.country;
    }

    if (this.toLocation !== null) {
      this.afleverAdres.plaatsnaam = this.toLocation.address.freeformAddress;
      this.afleverAdres.land = this.toLocation.address.country;
    }
  },
  computed: {
    ...mapFields([
      "ophalen",
      "ophalenLift",
      "aflever",
      "afleverLift",
      "routes",
      "typeTransport",
      "ophaalAdres",
      "afleverAdres",
      "toLocation",
      "fromLocation"
    ]),
    requireOphalenLift() {
      return this.ophalen === "beganegrond";
    },
    requireAfleverLift() {
      return this.aflever === "beganegrond";
    },
    isNotVerhuizing() {
      return this.typeTransport !== "verhuizing";
    }
  },
  validations: {
    ophalen: {
      required
    },
    aflever: {
      required
    },
    ophalenLift: {
      required: requiredUnless("requireOphalenLift")
    },
    afleverLift: {
      required: requiredUnless("requireAfleverLift")
    },
    ophaalAdres: {
      contact: {
        required: requiredIf("isNotVerhuizing")
      },
      telefoon: {
        required: requiredIf("isNotVerhuizing")
      },
      adres: {
        required
      },
      postcode: {
        required
      },
      plaatsnaam: {
        required
      }
    },
    afleverAdres: {
      contact: {
        required: requiredIf("isNotVerhuizing")
      },
      telefoon: {
        required: requiredIf("isNotVerhuizing")
      },
      adres: {
        required
      },
      postcode: {
        required
      },
      plaatsnaam: {
        required
      }
    }
  },
  methods: {
    nextStep() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$root.goToNextRoute();
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 30px 40px;
  border: 1px solid var(--light-grey);
  margin-bottom: 10px;

  .h2 {
    margin: 0;
  }
}

.row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 10px;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr !important;
  }
}

.form-group.disabled {
  opacity: 0.4;
}

.btn.btn__filled.w-100 {
  margin-top: 20px;
}
</style>
